const pushGa4Event = (event) => {
  const payload = {
    ...event,
    event_type: "GA4Event"
  }
  window.dataLayer = window.dataLayer || []

  if (payload.ecommerce) window.dataLayer.push({ ecommerce: null }) // Recommended per docs
  window.dataLayer.push(payload)

  // Nullify `event_type` to prevent recursive merge issues on successive data layer
  // pushes from other sources. E.g. a third-party push to the data layer could
  // inadvertently trigger GA4 tags in GTM if this param is still present.
  window.dataLayer.push({ event_type: null })
}

export {
  pushGa4Event
};



// WEBPACK FOOTER //
// ./shared/helpers/ga4_helper.js